<template>
  <div>
    <v-container grid-md > 
        <v-layout style="display: flex; flex-wrap: wrap;">
          <v-flex md12 d-flex > 
            <main >
            <Login />

            <OrDivider  />

            <SocialSignIn :heading="'Sign in with social'"/>

            
          </main>
          </v-flex>
         
        </v-layout>
      </v-container>
  </div>
</template>

<script>
  import Login from '@/components/Login'
  import SocialSignIn from '@/components/SocialSignIn'
  import OrDivider from '@/components/OrDivider'

  export default {
    components: {
      SocialSignIn,
      Login,
      OrDivider
    },
    data() {
      return {
        from: null,
        appLogin: false,
        loggedIn: true //assume they are logged in
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-login' || this.$router.currentRoute.path === '/app/login'){
        this.appLogin = true
        localStorage.appLogin = true
      }
      if(this.$getAuthenticatedUser() != null) {
        this.loggedIn = true;
      }else{
        this.loggedIn = false;
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
            console.log('before route enter')
            // TODO: Make sure we handle people referred from password reset with a message on sign in page 
        });
    },
    
    
  }
</script>
<style lang="scss" scoped>

.login-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

</style>
